import {Table, Tag} from "antd";
import moment from "moment";
import React from "react";

const TransferList = ({transfers}) => {
    return (
        <div>
            <h3>Transfer Listesi</h3>
            <Table dataSource={transfers}>
                <Table.Column title="Transfer Adı" dataIndex="transferName" key="transferName" />
                <Table.Column
                    title="Nereden"
                    dataIndex="from"
                    key="from"
                    render={from => from?.name}
                />
                <Table.Column title="Nereye" dataIndex="to" key="to" render={to => to?.name} />
                <Table.Column
                    title="Kurye Adı"
                    dataIndex="courier"
                    key="courier"
                    render={courier => courier?.fullname || "-"}
                />
                <Table.Column
                    title="Oluşturulma Zamanı"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt => moment(createdAt).format("DD-MM-YYYY HH:mm")}
                />
                <Table.Column
                    title="Tipi"
                    dataIndex="type"
                    key="type"
                    render={type => type || "-"}
                />
                <Table.Column
                    title="Durum"
                    dataIndex="status"
                    key="status"
                    render={status =>
                        status === "availableForDepot" ? (
                            <Tag color="blue">Depoya gitmeye hazır</Tag>
                        ) : status === "availableForPickup" ? (
                            <Tag color="blue">Teslimata hazır</Tag>
                        ) : status === "completed" ? (
                            <Tag color="green">Tamamlandı</Tag>
                        ) : status === "closed" ? (
                            <Tag color="red">İptal edildi</Tag>
                        ) : status === "created" ? (
                            <Tag color="blue">Oluşturuldu</Tag>
                        ) : (
                            "-"
                        )
                    }
                />
            </Table>
        </div>
    );
};

export default TransferList;
